import setShippingAddressesOnCartItemsMutation from '../../graphql/mutations/setShippingAddressesOnCartItems.graphql'
import types from './types'

export const actions = {

  setShippingAddressForItems ({ commit }, payload) {
    commit(types.SET_SHIPPING_ADDRESS_FOR_ITEMS, payload)
  },

  setShippingForItems ({ commit, rootGetters }, payload = false) {
    const items = rootGetters['checkout/getFilteredItems']

    commit(types.SET_SHIPPING_FOR_ITEMS, { items, isPaczkomatSelected: payload })
  },

  async setShippingData ({ commit, state, dispatch }, payload) {
    const cartId = this.$cart.cartId()

    await this.$graphql({
      requestPayload: {
        mutation: setShippingAddressesOnCartItemsMutation,
        variables: {
          input: {
            cartId,
            addressesItemsRelations: payload,
          },
        },
      },

      successHandler: async ({ data: { setShippingAddressesOnCartItems } }) => {
        const { cart: { shippingAddresses } } = setShippingAddressesOnCartItems

        await commit(types.IS_SAME_AS_SHIPPING_SENT, shippingAddresses)
        await commit(types.SET_SHIPPING_PRICE, setShippingAddressesOnCartItems)

        await dispatch('checkout/updatePricesWithShipping', setShippingAddressesOnCartItems.cart, { root: true })
      },
    })
  },

  async updateShipping ({ commit, rootGetters }, payload) {
    const items = rootGetters['checkout/getFilteredItems']

    await commit(types.UPDATE_SHIPPING, items)

    if (process.client) {
      await commit(types.SET_SHIPPING_PRICE, { cart: payload })
    }
  },

  setIsSameAsShippingSent ({ commit }, payload) {
    commit(types.IS_SAME_AS_SHIPPING_SENT, payload)
  },

  setShippingType ({ commit }, payload) {
    commit(types.SET_SHIPPING_TYPE, payload)
  },

  setPoint ({ commit }, payload) {
    commit(types.SET_POINT, payload)
  },

  setPointDetail ({ commit }, payload) {
    commit(types.SET_POINT_DETAIL, payload)
  },
}
